import { render, staticRenderFns } from "./wavesurfer.vue?vue&type=template&id=12714382&"
import script from "./wavesurfer.vue?vue&type=script&lang=js&"
export * from "./wavesurfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports